import { useContext } from 'react';

import { UserContext } from '../user/User.context';
import { Guard } from './guard';

export default function DocumentAdminGuard(): Guard {
  const { user } = useContext(UserContext);
  return {
    canActivate: () => (user?.roles || []).some(r => r.name === 'DocumentAdmin')
  };
}
